import React, { useState } from "react";
import { ChangeRate } from "../../pages";
import * as yup from "yup";
import { ExchangeController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { useScroll } from "framer-motion";

const ChangeRateContainer = ({ closeModal, rateModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    fromCurrency: yup.string().required("From Currency is required"),
    toCurrency: yup.string().required("To Currency is required"),
    ngnRate: yup
      .number()
      .required("NGN Rate is required")
      .typeError("NGN Rate must be a number"),
    maxMarketRate: yup
      .number()
      .required("Max Market Rate is required")
      .typeError("Max Market Rate must be a number"),
    minMarketRate: yup
      .number()
      .required("Min Market Rate is required")
      .typeError("Min Market Rate must be a number"),
    moneyExRate: yup
      .number()
      .required("Money Exchange Rate is required")
      .typeError("Money Exchange Rate must be a number"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      fromCurrency: values.fromCurrency,
      toCurrency: values.toCurrency,
      ngnRate: values.ngnRate,
      maxMarketRate: values.maxMarketRate,
      minMarketRate: values.minMarketRate,
      moneyExRate: values.moneyExRate,
      businesses: values.businesses,
    };
    const { status } = await ExchangeController.createExchangeRate(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    ExchangeController.getExchangeRate();
    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <ChangeRate
      rateModal={rateModal}
      loading={loading}
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    />
  );
};
export default ChangeRateContainer;
